import React from "react";

// components
import SelectInput from "../../../components/elements/form/SelectInput";
import TextBox from "../../../components/elements/form/TextBox";
import Button from "../../../components/elements/form/Button";

// state
import { get_countries, get_states } from "../../../service/api/misc";
import { request_service } from "../../../service/api/service";
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  IServiceRequestData,
  IServiceRequestDataError,
} from "../../../store/@types/service";
import Modal from "../../../components/ui/modal";

type IMakeRequest = {
  id: string;
  visible: boolean;
  onFinish: () => void;
  type: "new" | "renew";
};

const MakeRequest: React.FC<IMakeRequest> = ({
  id,
  visible,
  onFinish,
  type,
}) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ service }) => service.loading);
  const countries = useAppSelector(({ misc }) => misc.countries);
  const states = useAppSelector(({ misc }) => misc.states);
  const [data, dataSet] = React.useState<IServiceRequestData>({
    service_id: "",
    state_id: "",
    country_id: "",
    others: "",
    type: "new",
  });

  const [error, errorSet] = React.useState<IServiceRequestDataError>({
    state_id: "",
    country_id: "",
    others: "",
    service_id: "",
    type: "",
  });

  const setId = React.useCallback(() => {
    if (id && type) dataSet((prev) => ({ ...prev, service_id: id, type }));
  }, [id, type]);

  const onLoad = React.useCallback(() => {
    get_countries(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
    setId();
  }, [onLoad, setId]);

  const onSubmit = async () => {
    if (!data.state_id) {
      errorSet((prev) => ({
        ...prev,
        state_id: "warning",
        country_id: "warning",
      }));
      return;
    }

    const response = await request_service(dispatch, data);
    if (response) onFinish?.();
  };

  return (
    <Modal
      open={visible}
      onClose={() => {
        // dataSet({
        //   service_id: "",
        //   state_id: "",
        //   country_id: "",
        //   others: "",
        //   type: "new",
        // });
        // onFinish();
      }}
    >
      <div className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <SelectInput
            label="Country"
            labelClassName="text-dark"
            items={countries}
            name="country"
            value={data.country_id}
            status={error.country_id}
            onChange={(e) => {
              get_states(e.target.value, dispatch);
              dataSet((prev) => ({ ...prev, country_id: e.target.value }));
            }}
            className="capitalize"
          />

          <SelectInput
            label="State"
            labelClassName="text-dark"
            items={states}
            name="state_id"
            status={error.state_id}
            value={data.state_id}
            onChange={(e) => {
              dataSet((prev) => ({ ...prev, state_id: e.target.value }));
              errorSet((prev) => ({
                ...prev,
                country_id: "",
                state_id: "",
              }));
            }}
          />
        </div>
        <div className="mt-3 md:mt-0">
          <TextBox
            label="Others"
            labelClassName="text-dark"
            name="others"
            placeholder="Enter addition or exception"
            status={error.others}
            value={data.others}
            rowsValue={3}
            onChange={(e) =>
              dataSet((prev) => ({ ...prev, others: e.target.value }))
            }
          />
        </div>

        <Button
          title="Make Request"
          onHandler={onSubmit}
          loading={loading}
          className="w-full text-[white] bg-primary-500 hover:bg-primary-800 transition-colors ease-out duration-300 rounded-xl"
        />
      </div>
    </Modal>
  );
};

export default MakeRequest;
